import { asyncRouterMap, constantRouterMap } from "@/config/router.config";
import cloneDeep from "lodash.clonedeep";

function determineRouter(route, permission) {
  for (let i = 0; i < permission.length; i++) {
    let item = permission[i];
    if (item.path == undefined && item.children.length != 0) {
      determineRouter(route, item.children);
    }
    if (route.path == item.path) {
      console.log(route);
      return true;
    } else if (route.redirect && route.redirect == item.path) {
      return true;
    }
  }
  return false;
}
/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission(permission, route) {
  if (route.meta && route.meta.title) {
    if (permission === undefined) {
      return false;
    }
    // let flag = false;
    if (route.path == "/" || route.path == "/hourSystem" || route.path.startsWith("/joinProjectApproval") 
    || route.path == "/backend" || route.path == "/hourReplenish" || route.path == "/joinProject" || route.path == "/importFailure" ) {
      return true;
    }

    // return determineRouter(route, permission);
    for (let i = 0, len = permission.length; i < len; i++) {
      //console.info("permission.name="+permission[i].name);
      //console.info("path="+permission[i].path+",route.path="+route.path+",name="+permission[i].name+",title="+route.meta.title);
      if (route.path == permission[i].path) {
        route.meta.title = permission[i].name;
        return true;
      } else if (route.hidden == true) {
        return true;
      }
    }
    console.info("return false +++++ route path="+route.path+",title="+route.meta.title);
    return false;
  }
  return false;
}

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id);
  } else {
    return true;
  }
}

function filterAsyncRouter(routerMap, role) {
  const accessedRouters = routerMap.filter((route) => {
    if (hasPermission(role.permissionList, route)) {
      if (route.children && route.children.length > 0) {
        route.children = filterAsyncRouter(route.children, role);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve) => {
        const { role } = data;
        const routerMap = cloneDeep(asyncRouterMap);
        console.log("GenerateRoutes data=",data);
        console.log("GenerateRoutes role=",role);
        console.log("GenerateRoutes routerMap=",routerMap);
        // var roles = {
        //   permissionList: [
        //     "hourSystem",
        //     "dashboard",
        //     "hoursDeclaration",
        //     "statisticalReport",
        //     "system",
        //     "workHoursLibrary",
        //     "operationMaintenance",
        //     "thirdParty",
        //   ],
        // };
        const accessedRouters = filterAsyncRouter(routerMap, role);
        console.log("accessedRouters=",accessedRouters);
        //const menuList = data.userAuth.menuList;
        //console.log("GenerateRoutes menuList=",menuList);
        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    },
  },
};

export default permission;
